import React, { Component, Fragment } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { connect } from 'react-redux';
import { Modal, message } from 'antd';
import ConfrimIframeModal from '../../iframModal/ConfrimIframeModal';
import ManualAuthentication from './manualAuthentication';
import { _change_bind_cert_modal, _get_user_info } from '../../../store/Action';
import Util from '../../../script/util';
import HTTP from '../../../script/service';
import { QRCodeCanvas } from 'qrcode.react';
import './authentication.scss';

// eslint-disable-next-line no-useless-escape
const RealNameReg = /^([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$)/;

class index extends Component {
  state = {
    visible: false,
    realName: '',
    certNo: '',
    isQRcode: false, // 展示二维码
    param: null,
    isShowResult: false, // 展示认证结果
    isCertifyResult: false, // 认证结果
    isShowComplete: false, // 是否展示完成按钮
  };
  // 刷新数据
  refresh = () => {
    _get_user_info();
  };
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  close = () => {
    this.setState({
      isQRcode: false,
      isShowResult: false,
      isCertifyResult: false,
      param: null,
    });
    _change_bind_cert_modal(false);
  };
  commit = () => {
    const { realName, certNo } = this.state;
    if (!realName || realName.length < 2) {
      message.error('请填写真实姓名');
      return;
    }
    if (!RealNameReg.test(realName)) {
      message.error('请正确填写您的真实姓名');
      return;
    }
    if (!certNo) {
      message.error('请填写身份证号码');
      return;
    }
    if (certNo.length !== 18) {
      message.error('请正确填写身份证号码');
      return;
    }
    let birthday = certNo.substr(6, 8);
    birthday =
      birthday.slice(0, 4) +
      '-' +
      birthday.slice(4, 6) +
      '-' +
      birthday.slice(6);
    const age = Util.birthdayCalcAge(birthday);
    if (age < 18) {
      message.warning('请提供18岁到45岁之间的身份证信息');
      return;
    }

    HTTP._v2_openCertify({
      uid: this.props.base.uid,
      certName: realName,
      certNo,
      retUrl: '',
    }).then((res) => {
      if (res.code === 200) {
        // todo 二维码
        this.setState({ isQRcode: true, param: res.data }, () => {
          this.timer = setTimeout(() => {
            this.setState({ isShowComplete: true });
          }, 4000);
        });
      } else {
        message.error(res.message || '获取认证二维码失败');
      }
    });
  };
  changeRealName = (e) => {
    this.setState({
      realName: e.target.value,
    });
  };
  changeCertNo = (e) => {
    this.setState({
      certNo: e.target.value,
    });
  };
  openModel = (title, url) => {
    const {
      base: { rootConfig },
    } = this.props;
    const mobilePath = rootConfig?.protocolPath || rootConfig.mobilePath;
    let modalurl = mobilePath + url + '?v=' + rootConfig.version;
    this.confirmElement.showModal({
      url: modalurl,
      title: title,
      scrolling: 'yes',
      width: '1000px',
      height: '600px',
    });
    window.onSuccess = (msg) => {
      if (msg.data === 'newGod') {
        this.hideModal();
        this.confirmElement.hideModal();
        this.props.applyAll(true);

        window.removeEventListener('message', window.onSuccess);
      }
    };
    window.addEventListener('message', window.onSuccess);
  };
  // 人工认证
  manualAuthenticate = () => {
    const { realName, certNo } = this.state;
    this.manualAuthenticateElement.showModal({ realName, certNo });
  };
  manualCallback = () => {
    this.refresh();
    this.close();
  };
  // 我已完成认证
  confirmSuccess = () => {
    const { param } = this.state;

    const params = {
      uid: this.props.base.uid,
      certifyId: param.certifyId,
    };
    HTTP._v2_openCertifyStatus(params).then((res) => {
      if (res && res.code === 200) {
        this.setState({ isShowResult: true, isCertifyResult: !!res.data });
      }
      this.refresh();
    });
  };
  // 重新认证
  handleResetCertify = () => {
    this.setState({
      isQRcode: false,
      isShowResult: false,
      isCertifyResult: false,
      param: null,
    });
  };
  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { bindCert_visible } = this.props.base;
    const {
      realName,
      certNo,
      isQRcode,
      param,
      isShowResult,
      isCertifyResult,
      isShowComplete,
    } = this.state;
    const { close, changeRealName, changeCertNo, commit } = this;
    return (
      <Fragment>
        <Modal
          destroyOnHidden={true}
          footer={null}
          centered={true}
          open={bindCert_visible}
          className="daidai-modal-style has-top-border host-step-container"
          width="800px"
          title={'实名认证'}
          onCancel={close}
          maskClosable={false}
        >
          <div className="host-enter-auth host-enter-tab">
            {!isShowResult ? (
              !isQRcode && !param ? (
                <div className="auth-form host-enter-tabcontent">
                  <h4 className="sub-title">
                    认证信息将用于大神入驻、收益提现等，与账号唯一绑定，我们会对信息进行严格保密
                  </h4>
                  <div className="info-form-row">
                    <span className="info-form-label">真实姓名 :</span>
                    <input
                      className="info-form-input"
                      autoComplete="off"
                      placeholder="请输入您的真实姓名"
                      value={realName}
                      onChange={changeRealName}
                      maxLength="15"
                    />
                  </div>
                  <div className="info-form-row">
                    <span className="info-form-label">身份证号 :</span>
                    <input
                      className="info-form-input"
                      autoComplete="off"
                      placeholder="请输入您的身份证号"
                      value={certNo}
                      onChange={changeCertNo}
                    />
                  </div>
                  <div className="form-btns">
                    <p className="desc">
                      已阅读并同意
                      <span
                        onClick={this.openModel.bind(
                          this,
                          '用户协议',
                          '/appagreement/index.html'
                        )}
                      >
                        《平台用户协议》
                      </span>
                      和
                      <span
                        onClick={this.openModel.bind(
                          this,
                          '隐私协议',
                          '/privacy/index.html'
                        )}
                      >
                        《隐私协议》
                      </span>
                    </p>
                    <button className="daidai-btn-primary" onClick={commit}>
                      同意协议并认证
                    </button>
                    {/* <Button type="link" className="manual-text" onClick={this.manualAuthenticate}>人工认证</Button> */}
                  </div>
                </div>
              ) : (
                <div className="qcode-wrap">
                  <p className="qcode-sub-title">
                    请使用支付宝APP扫一扫下方二维码进行实名认证
                  </p>
                  <div className="qcode">
                    <QRCodeCanvas
                      value={param.url}
                      size={300}
                      bgColor={'#FFF'}
                      fgColor={'#000'}
                    />
                  </div>
                  <p className="qcode-footer-text">
                    支付宝实名信息需与您填写的实名信息保持一致
                  </p>
                  {isShowComplete ? (
                    <button
                      className="daidai-btn-primary"
                      onClick={this.confirmSuccess}
                    >
                      我已完成认证
                    </button>
                  ) : null}
                </div>
              )
            ) : null}

            {isShowResult ? (
              <div className="certify-result">
                {isCertifyResult ? (
                  <Fragment>
                    <i className="icon-success" />
                    <p>实名认证成功</p>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div className="icon-error" />
                    <p>实名认证失败</p>

                    <p>请仔细核对您的姓名和身份证号码</p>

                    <div className="form-btns">
                      <button
                        className="daidai-btn-primary"
                        onClick={this.handleResetCertify}
                      >
                        重新认证
                      </button>
                    </div>
                  </Fragment>
                )}
              </div>
            ) : null}
          </div>

          <ManualAuthentication
            wrappedComponentRef={(el) => (this.manualAuthenticateElement = el)}
            base={this.props.base}
            callback={this.manualCallback}
          />
          <ConfrimIframeModal
            wrappedComponentRef={(el) => (this.confirmElement = el)}
          />
        </Modal>
      </Fragment>
    );
  }
}

export default connect((store) => ({ base: store }))(
  withRouter(index, { withRef: true })
);
